export const users = {
  items: [
    {
      id: 'f06665fd-2bba-470f-bf13-c209f60a4976',
      email: 'iehorpetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-03-25T00:00:00Z',
      fullName: 'Єгор Петренко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '2bdba0bf-a791-4e8e-9493-9e3fb3f6862a',
      email: 'levskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-30T00:00:00Z',
      fullName: 'Лев Скрипко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '4c02f3be-56e2-4717-9f3a-776a37dc5f84',
      email: 'ostaprybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-04-05T00:00:00Z',
      fullName: 'Остап Рибак',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: 'c135ed79-38a6-4d28-a1a8-964cc140e4d0',
      email: 'andriirybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-01-20T00:00:00Z',
      fullName: 'Андрій Рибак',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '0729aedb-7019-4958-bd82-60c4a9078d97',
      email: 'romanskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-02-20T00:00:00Z',
      fullName: 'Роман Скрипко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '629d3996-678c-45e8-92ed-3ead066f3d13',
      email: 'iaroslavhrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-02-15T00:00:00Z',
      fullName: 'Ярослав Гриценко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '93c504b4-2cca-4eb4-9a73-be0d2dc67c82',
      email: 'oleksiilytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-06T00:00:00Z',
      fullName: 'Олексій Литвин',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '1e19180d-3c9d-458e-86c7-01a2ac5bddaf',
      email: 'iehorshevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-12-14T00:00:00Z',
      fullName: 'Єгор Шевченко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '183bbb26-ea0b-477a-a2da-98fc72d45025',
      email: 'serhiionyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-09-15T00:00:00Z',
      fullName: 'Сергій Онищенко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '6fb635ce-4196-4298-830b-06aa7756d7f3',
      email: 'andriisobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2024-02-03T00:00:00Z',
      fullName: 'Андрій Соболь',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '2d59d765-5421-4607-8f2f-6f2244789f87',
      email: 'bohdanpetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-11-12T00:00:00Z',
      fullName: 'Богдан Петренко',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: '407c417c-e5d6-4317-91ab-8588382b938d',
      email: 'serhiimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-06-30T00:00:00Z',
      fullName: 'Сергій Мельник',
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          name: 'Team Revenue',
          description: 'Team Revenue of Sales Department',
        },
      ],
    },
    {
      id: 'ff4c8d8e-1852-4984-86ea-8d191c3812da',
      email: 'markoshevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-01-14T00:00:00Z',
      fullName: 'Марко Шевченко',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: '33893181-28b8-4328-a170-69e5672fa93e',
      email: 'iaroslavkravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-06T00:00:00Z',
      fullName: 'Ярослав Кравчук',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: '10eb6bd0-4a80-4b4f-96f7-675681409705',
      email: 'ihorlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-12-04T00:00:00Z',
      fullName: 'Ігор Литвин',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: 'b3f4c867-6313-4181-9468-8588372406b7',
      email: 'dmytrosobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-12-20T00:00:00Z',
      fullName: 'Дмитро Соболь',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: '6a72cd28-dd41-46ff-9213-515b8d9580a3',
      email: 'markosobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-04-23T00:00:00Z',
      fullName: 'Марко Соболь',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: '8b00487d-a78b-4b72-9fae-1496bb5b50c0',
      email: 'tymurpetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-06-28T00:00:00Z',
      fullName: 'Тимур Петренко',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: 'afd60d19-dbbd-4235-8e98-98a3457ca173',
      email: 'vitaliikovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-24T00:00:00Z',
      fullName: 'Віталій Коваленко',
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          name: 'Team Outreach',
          description: 'Team Outreach of Sales Department',
        },
      ],
    },
    {
      id: '0e56101c-4488-47a9-a7bb-4a1691cb446b',
      email: 'iaroslavpetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-01-25T00:00:00Z',
      fullName: 'Ярослав Петренко',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },

    {
      id: '270d3cc1-9b6c-4027-b0ad-965ad815a470',
      email: 'markorybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-04-21T00:00:00Z',
      fullName: 'Марко Рибак',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: '1d37caf5-bc11-434e-b4ff-e82e53026f2b',
      email: 'tymuronyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-11-17T00:00:00Z',
      fullName: 'Тимур Онищенко',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: 'e05814a4-6504-4240-8d7a-dfb4eadc6973',
      email: 'andriikhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-09-17T00:00:00Z',
      fullName: 'Андрій Хоменко',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: '270554e1-e7cb-4c04-b47c-7e373350a853',
      email: 'ostapsobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-01T00:00:00Z',
      fullName: 'Остап Соболь',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: '65aa6746-27cc-4ef3-a339-048bf6d52e0b',
      email: 'romanskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-10-08T00:00:00Z',
      fullName: 'Роман Скрипко',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: '52ee1e59-5070-45ea-aa91-cf3877804e9c',
      email: 'dmytropetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-01-20T00:00:00Z',
      fullName: 'Дмитро Петренко',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: '587ca6f3-6a2b-4ee9-a224-43b0525af9a2',
      email: 'andriikravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-03-13T00:00:00Z',
      fullName: 'Андрій Кравчук',
      teams: [
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          name: 'Team CRM',
          description: 'Team CRM of Sales Department',
        },
      ],
    },
    {
      id: 'e1770c6a-b71c-48ca-abf6-70a3f669d026',
      email: 'bohdanrybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-06T00:00:00Z',
      fullName: 'Богдан Рибак',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'e1770c6a-b71c-48c22abf6-70a3f669d026',
      email: 'viktorrybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-06T00:00:00Z',
      fullName: 'Віктор Рибак',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'e1770c6a-b71c-48ca-asdbf6-70a3f669d026',
      email: 'lesyavishinska@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-06T00:00:00Z',
      fullName: 'Леся Вощинська',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'e1770c6a-b71c-48ca-abf6-sdsdsdsd026',
      email: 'vikasmol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-06T00:00:00Z',
      fullName: 'Віка Смоленська',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'e1770c6a-b71c-48ca-abf6-gd70a3f669d026',
      email: 'kostya@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-06T00:00:00Z',
      fullName: 'Антон Рибак',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '5e11f66e-2d4b-471e-a662-86c7ace21115',
      email: 'andriikravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-04-18T00:00:00Z',
      fullName: 'Андрій Кравчук',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '83e8590c-ef59-49b3-90dd-9c6940cb8d01',
      email: 'romanlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-08-04T00:00:00Z',
      fullName: 'Роман Литвин',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '808de3aa-3f3e-4a42-b727-1d578e2c58d5',
      email: 'bohdankhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-03-01T00:00:00Z',
      fullName: 'Богдан Хоменко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'a1c5d85c-346d-4183-819e-c5f30eb96a7d',
      email: 'tymurkovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-10-23T00:00:00Z',
      fullName: 'Тимур Коваленко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '3378d9c2-e278-40f1-82a7-b29c31a86c02',
      email: 'ihorkravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-08-13T00:00:00Z',
      fullName: 'Ігор Кравчук',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '9d9a4508-0dca-4f87-8a2c-470533e2e68f',
      email: 'iuriishevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-08-21T00:00:00Z',
      fullName: 'Юрій Шевченко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '48d32bdd-fb4f-4a6f-84c1-ffd916eb1bc7',
      email: 'vitaliizinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-07-06T00:00:00Z',
      fullName: 'Віталій Зінченко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'bf541129-b2b9-4cb0-9d43-149ae9a7c090',
      email: 'vitaliikravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-02-23T00:00:00Z',
      fullName: 'Віталій Кравчук',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: '00456a48-7630-477b-acae-64ac5602a576',
      email: 'tymurzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-09T00:00:00Z',
      fullName: 'Тимур Зінченко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'da79d7f9-4e38-4e33-965d-f82d9b0769c6',
      email: 'bohdankhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-01-30T00:00:00Z',
      fullName: 'Богдан Хоменко',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'b2144779-f7d0-4aa8-8fad-067d03b53823',
      email: 'levmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-04T00:00:00Z',
      fullName: 'Лев Мельник',
      teams: [
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          name: 'Frontend Team',
          description: 'Frontend Team of Development Department',
        },
      ],
    },
    {
      id: 'cf0a2e20-b910-4c1e-adad-8ed61185107d',
      email: 'vitaliimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-06-23T00:00:00Z',
      fullName: 'Віталій Мельник',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '6f67c00f-5053-4584-a5af-f2651e22dbeb',
      email: 'iaroslavstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-06-27T00:00:00Z',
      fullName: 'Ярослав Степаненко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '26f6e7e7-b174-43d8-b3a0-3dce615fddf0',
      email: 'iaroslavhrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-04-12T00:00:00Z',
      fullName: 'Ярослав Гриценко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'ba43f647-8587-4954-b98c-ed40486b5958',
      email: 'tymursobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-10-01T00:00:00Z',
      fullName: 'Тимур Соболь',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'e5858e46-88c5-46b5-ab82-c1f0932ba886',
      email: 'romanzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-07-05T00:00:00Z',
      fullName: 'Роман Зінченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '8f412aaf-2bc4-4b6e-9dde-f1ae5be92d95',
      email: 'tarasshevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-03-06T00:00:00Z',
      fullName: 'Тарас Шевченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '35febe38-1fcf-4a81-827b-240674ce38fb',
      email: 'levzakharchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-06-09T00:00:00Z',
      fullName: 'Лев Захарченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'c159219b-a0d7-4e3c-9cbd-25b03d61f1b8',
      email: 'ostapzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-01-19T00:00:00Z',
      fullName: 'Остап Зінченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'a07c1a08-3259-4ef8-a2e1-8cecc913d8e2',
      email: 'mykytakovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-10-21T00:00:00Z',
      fullName: 'Микита Коваленко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '7f36ed98-07bf-48f4-bcec-ce2d1f0f8f8e',
      email: 'iuriipetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-11T00:00:00Z',
      fullName: 'Юрій Петренко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '566bed72-8673-4a75-bf22-62245fc60514',
      email: 'tymurzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-11-09T00:00:00Z',
      fullName: 'Тимур Зінченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '653ba72a-de71-4d26-bf79-6bb75c8d3424',
      email: 'bohdanzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-10-01T00:00:00Z',
      fullName: 'Богдан Зінченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '05e5f67c-4d71-42a4-9f4f-4e8e241630a9',
      email: 'taraskhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-02-19T00:00:00Z',
      fullName: 'Тарас Хоменко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '66a57057-c7a5-4206-bf3c-bde9d40b9842',
      email: 'levhrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-14T00:00:00Z',
      fullName: 'Лев Гриценко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '53b6dcff-8358-4de6-9c02-246d246fcbf9',
      email: 'taraszinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-08T00:00:00Z',
      fullName: 'Тарас Зінченко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'd5b306d0-19a1-4c30-a133-ea201ea012c8',
      email: 'taraskravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-02-10T00:00:00Z',
      fullName: 'Тарас Кравчук',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'e2b3750d-b17d-45b2-ad53-f27c974afd93',
      email: 'iuriikhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-08-06T00:00:00Z',
      fullName: 'Юрій Хоменко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '71844cbd-c1de-4434-ac36-981b6bffd3c8',
      email: 'oleksiikovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-02T00:00:00Z',
      fullName: 'Олексій Коваленко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'cd0ebab6-0848-4b96-b49b-255f0186955b',
      email: 'ostaplytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-26T00:00:00Z',
      fullName: 'Остап Литвин',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: 'b50b78ed-aeb0-41ba-a8ff-1b3ab8ce988d',
      email: 'serhiikovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-01-11T00:00:00Z',
      fullName: 'Сергій Коваленко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '56c4be9b-2c36-4100-b9ae-91a7ca5d72ee',
      email: 'mykytapetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-11-07T00:00:00Z',
      fullName: 'Микита Петренко',
      teams: [
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          name: 'Backend Team',
          description: 'Backend Team of Development Department',
        },
      ],
    },
    {
      id: '627f2b21-5d90-4983-aa74-16e3f0a06754',
      email: 'bohdanshevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-10-16T00:00:00Z',
      fullName: 'Богдан Шевченко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '854dc0d8-54c2-47ca-85e1-4c9a1015b81c',
      email: 'serhiilytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-04-08T00:00:00Z',
      fullName: 'Сергій Литвин',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: 'e9575e78-9e58-4f23-a31c-dd9a065be644',
      email: 'dmytrostepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-04-15T00:00:00Z',
      fullName: 'Дмитро Степаненко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '01c05725-2173-464a-96d9-4cc5088bd2a3',
      email: 'bohdankhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-06T00:00:00Z',
      fullName: 'Богдан Хоменко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: 'ee3cdad0-6ce5-41b3-b4e8-c4d48371a586',
      email: 'ostaplytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-07-27T00:00:00Z',
      fullName: 'Остап Литвин',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '6dce50a8-1bbf-46a3-a0b8-b6f688d1cdfb',
      email: 'iaroslavsobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-03-24T00:00:00Z',
      fullName: 'Ярослав Соболь',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '3682f68f-e6aa-4b82-84a9-0637658c3f7b',
      email: 'andriikhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-09-17T00:00:00Z',
      fullName: 'Андрій Хоменко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },

    {
      id: '847e7ad6-d673-48b3-8599-9033fe603150',
      email: 'andriiskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-21T00:00:00Z',
      fullName: 'Андрій Скрипко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: 'dfc86f49-bca3-441d-9eef-53438064ffdf',
      email: 'iehorkhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-16T00:00:00Z',
      fullName: 'Єгор Хоменко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '16b91a27-df02-4607-a99d-e7af18c0e128',
      email: 'levsobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-04-14T00:00:00Z',
      fullName: 'Лев Соболь',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: 'd290febe-925a-4e15-8a3c-589c5420cbcf',
      email: 'ihorzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-03-22T00:00:00Z',
      fullName: 'Ігор Зінченко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: '8faef4b1-e909-478e-9f54-2f09d5633fe3',
      email: 'bohdanskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-07-29T00:00:00Z',
      fullName: 'Богдан Скрипко',
      teams: [
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          name: 'DevOps Team',
          description: 'DevOps Team of Development Department',
        },
      ],
    },
    {
      id: 'cbbda28c-45ae-40b4-8a75-670a0cc300bf',
      email: 'serhiizinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-09-19T00:00:00Z',
      fullName: 'Сергій Зінченко',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: 'aff0285e-2747-4d4a-b71b-fb6c3a989827',
      email: 'levlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-10-15T00:00:00Z',
      fullName: 'Лев Литвин',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: '106442af-686d-463b-ac7e-b208f55db0a5',
      email: 'bohdanskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-29T00:00:00Z',
      fullName: 'Богдан Скрипко',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: '0c58e073-dcd7-40b6-babe-92b4e70af309',
      email: 'andriizakharchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-03-24T00:00:00Z',
      fullName: 'Андрій Захарченко',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: 'e3c52669-2e29-4966-a3e6-fdfcef486ed9',
      email: 'markorybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-07-24T00:00:00Z',
      fullName: 'Марко Рибак',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: 'd7631907-5f1b-40e3-8f0f-fd44e92bd381',
      email: 'markolytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-10-28T00:00:00Z',
      fullName: 'Марко Литвин',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: 'b4e04b73-dbfc-44b2-bbc9-4632a0dff03e',
      email: 'ostapzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-02-12T00:00:00Z',
      fullName: 'Остап Зінченко',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: '45481007-6641-4738-a23d-e34db37ce702',
      email: 'iehormelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-11-25T00:00:00Z',
      fullName: 'Єгор Мельник',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: 'd2f13f9e-510a-4857-88e3-110ff7e59bf7',
      email: 'levhrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-05T00:00:00Z',
      fullName: 'Лев Гриценко',
      teams: [
        {
          id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
          name: 'UI Team',
          description: 'UI Team of Design Department',
        },
      ],
    },
    {
      id: '469c8228-2438-413f-af98-705ee56e7e85',
      email: 'markoskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-18T00:00:00Z',
      fullName: 'Марко Скрипко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },

    {
      id: 'd83f68cc-aa92-4ad7-833d-5ebba209bee5',
      email: 'levlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-21T00:00:00Z',
      fullName: 'Лев Литвин',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '39060d0d-101f-4c8c-b7be-42f737ece234',
      email: 'iaroslavonyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-01-24T00:00:00Z',
      fullName: 'Ярослав Онищенко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '8101a88f-eaed-4171-bdc0-d7486a0d6c26',
      email: 'iaroslavmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-01-26T00:00:00Z',
      fullName: 'Ярослав Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '4f616861-5f78-4526-bf50-a06e4dd4dcbd',
      email: 'iehorsobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-04-02T00:00:00Z',
      fullName: 'Єгор Соболь',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '1def266e-d3f5-4138-9dbe-ef3a7f92a51e',
      email: 'andriihrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-09-09T00:00:00Z',
      fullName: 'Андрій Гриценко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '1bff01bb-6d46-44d9-9cdc-32edda2faac4',
      email: 'iuriionyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-04-29T00:00:00Z',
      fullName: 'Юрій Онищенко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '1bec4c3c-103c-4f00-b12c-249ee413183f',
      email: 'romanzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-06-06T00:00:00Z',
      fullName: 'Роман Зінченко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '30c95f09-1d30-4b4d-947c-f8bca80a8f1f',
      email: 'andriishevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-04-04T00:00:00Z',
      fullName: 'Андрій Шевченко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '89327705-33cd-49cf-be15-852a380aebd1',
      email: 'andriimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-02-07T00:00:00Z',
      fullName: 'Андрій Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'ae2f74be-408d-4d3c-8bd8-addb79be0d2b',
      email: 'oleksiimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-04-24T00:00:00Z',
      fullName: 'Олексій Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '84db7119-5c21-4847-bb4c-78f791d8492b',
      email: 'taraspetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-29T00:00:00Z',
      fullName: 'Тарас Петренко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '33db7119-5c21-4847-bb4c-78f791d8492b',
      email: 'marchukbogdan@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-29T00:00:00Z',
      fullName: 'Бгдан Марчук',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '99db7119-5c21-4847-bb4c-78f791d8492b',
      email: 'olegkovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-29T00:00:00Z',
      fullName: 'Олег Коваленко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '66db7119-5c21-4847-bb4c-78f791d8492b',
      email: 'oleksiipetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-06-29T00:00:00Z',
      fullName: 'Олексій Петренко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'c5bf2f93-f31c-4714-9c31-e549f69c9cc0',
      email: 'bohdanmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-10-18T00:00:00Z',
      fullName: 'Богдан Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'b466d362-ad2a-4d1e-9e23-9ff2f5143725',
      email: 'iaroslavzinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-03-28T00:00:00Z',
      fullName: 'Ярослав Зінченко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '77835841-beaa-43df-9e06-6295fa663e71',
      email: 'serhiimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-01-29T00:00:00Z',
      fullName: 'Сергій Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '56635469-e7ba-4619-b69c-b56cefd3ff28',
      email: 'iuriilytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-05-30T00:00:00Z',
      fullName: 'Юрій Литвин',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'b01a7f70-e803-42bb-9936-2967ee8f248f',
      email: 'tymurzakharchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-20T00:00:00Z',
      fullName: 'Тимур Захарченко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'd821c6c4-fd9e-4b70-b243-004fac3edb40',
      email: 'oleksiionyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2024-01-07T00:00:00Z',
      fullName: 'Олексій Онищенко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '4baa4c62-b690-4b39-800b-f19172de9b96',
      email: 'oleksiihrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-23T00:00:00Z',
      fullName: 'Олексій Гриценко',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: '9296ee77-2489-4b11-a4c6-2f31622c02d3',
      email: 'tymurmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-03-01T00:00:00Z',
      fullName: 'Тимур Мельник',
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          name: 'UX Team',
          description: 'UX Team of Design Department',
        },
      ],
    },
    {
      id: 'd3f369a0-75ea-4fcd-a22c-9acf6d642c64',
      email: 'dmytrostepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-07-17T00:00:00Z',
      fullName: 'Дмитро Степаненко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a86b0023-778c-4c4f-a870-6e46c34d2a33',
      email: 'dmytrorybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-30T00:00:00Z',
      fullName: 'Дмитро Рибак',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a86b2023-778c-4c4f-a870-6e46c34d2a33',
      email: 'dmytyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-30T00:00:00Z',
      fullName: 'Дмитро Верещагін',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a86b23323-778c-4c4f-a870-6e46c34d2a33',
      email: 'zinazina@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-30T00:00:00Z',
      fullName: 'Зіна Верещагіна',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a86b0023-778c-4c4f-a870-6e46434d2a33',
      email: 'dariajagotynska@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-30T00:00:00Z',
      fullName: 'Дарія Яготинська',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a86b0023-778c-4c4f-a870-6e464d243433',
      email: 'dviktorsmolensky@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-30T00:00:00Z',
      fullName: 'Віктор Смоленський',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'e3b593b3-d5ca-4236-b0b1-fef488cbf23d',
      email: 'bohdanonyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-27T00:00:00Z',
      fullName: 'Богдан Онищенко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '770ea441-db1c-4304-9186-96f76211e1fe',
      email: 'tarasrybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-09-18T00:00:00Z',
      fullName: 'Тарас Рибак',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '69e94671-c7b9-4752-949c-4539daffe6d1',
      email: 'mykytastepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-02-10T00:00:00Z',
      fullName: 'Микита Степаненко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'e1f1bd08-6a19-4360-aed4-b395fbf3c7a3',
      email: 'iaroslavzakharchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-05-19T00:00:00Z',
      fullName: 'Ярослав Захарченко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '0b94f05c-0072-46ad-9fcf-4420230c2c27',
      email: 'iuriikravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2024-01-20T00:00:00Z',
      fullName: 'Юрій Кравчук',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'b663acc3-b40b-4e39-b4be-31609f472b39',
      email: 'markoskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-06-23T00:00:00Z',
      fullName: 'Марко Скрипко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '5fc288ed-3e84-4c4a-b42c-912b4e40b05e',
      email: 'taraspetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-02-07T00:00:00Z',
      fullName: 'Тарас Петренко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '23c853a6-6327-4657-9857-279bccd26307',
      email: 'romanzakharchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-08-03T00:00:00Z',
      fullName: 'Роман Захарченко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: 'c6979642-25b3-4a44-8ef0-f3632fce7e6f',
      email: 'bohdanstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-08-02T00:00:00Z',
      fullName: 'Богдан Степаненко',
      teams: [
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          name: 'Content Team',
          description: 'Content Team of Marketing Department',
        },
      ],
    },
    {
      id: '56fdc3c0-53b2-41d4-8d73-255f1a5770a4',
      email: 'romankhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-03-15T00:00:00Z',
      fullName: 'Роман Хоменко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '1b006f9b-52e4-4618-8326-a34f65f8ad0f',
      email: 'oleksiikravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-18T00:00:00Z',
      fullName: 'Олексій Кравчук',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '706bf318-39f0-4666-b484-397835058282',
      email: 'tarassobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-05T00:00:00Z',
      fullName: 'Тарас Соболь',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '931a5d32-6495-4221-9b43-f90529e3e08f',
      email: 'tarasskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-12-28T00:00:00Z',
      fullName: 'Тарас Скрипко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '28f9e837-98ec-46bb-a901-89b47ff1ae02',
      email: 'serhiionyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-02-22T00:00:00Z',
      fullName: 'Сергій Онищенко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '9cda8f7c-03be-4b83-84e7-54a19051c077',
      email: 'serhiikovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-02-17T00:00:00Z',
      fullName: 'Сергій Коваленко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: 'aa80e6aa-5ea8-4b1b-9cd7-661e7ee83436',
      email: 'iaroslavlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-01-09T00:00:00Z',
      fullName: 'Ярослав Литвин',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '96712918-ff0a-4e3d-a47e-39d66bef6ca6',
      email: 'mykytapetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-03-29T00:00:00Z',
      fullName: 'Микита Петренко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '48b08786-1c91-4aeb-98dc-fd09cb7581b7',
      email: 'dmytroonyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-03-02T00:00:00Z',
      fullName: 'Дмитро Онищенко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a087eedb-2194-41b6-a19b-b84b859b7f0b',
      email: 'tarasmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-01-15T00:00:00Z',
      fullName: 'Тарас Мельник',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '57d0780c-a14d-4f50-a091-4f3a90823c41',
      email: 'andriimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-01-12T00:00:00Z',
      fullName: 'Андрій Мельник',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: 'ec83a3bb-3ac2-4484-83a7-7db258b99a5b',
      email: 'bohdanstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-07-23T00:00:00Z',
      fullName: 'Богдан Степаненко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '3ee9e6f6-ecfe-4f08-a26d-c1adc8a87726',
      email: 'oleksiikhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-05-24T00:00:00Z',
      fullName: 'Олексій Хоменко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '9c9bcd06-15ec-40e9-bb18-08ffcf0589d6',
      email: 'tarashrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-08-28T00:00:00Z',
      fullName: 'Тарас Гриценко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '3b70c311-f36a-4ffb-adc4-2e5e5f8238c3',
      email: 'dmytrokhomenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-09-10T00:00:00Z',
      fullName: 'Дмитро Хоменко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: 'a742a897-7960-4e76-889a-3dc9950f6614',
      email: 'bohdansobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-07-14T00:00:00Z',
      fullName: 'Богдан Соболь',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '9bf2f15a-f06c-4c25-af1e-b04f623679e7',
      email: 'bohdanlytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-09-09T00:00:00Z',
      fullName: 'Богдан Литвин',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: '68314bd1-48e1-41f2-999b-869f67475fd2',
      email: 'tymurhrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-06-10T00:00:00Z',
      fullName: 'Тимур Гриценко',
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          name: 'Social Media Team',
          description: 'Social Media Team of Marketing Department',
        },
      ],
    },
    {
      id: 'ed5a9714-d27f-4e5a-a962-7409c458ccae',
      email: 'mykytalytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-09-05T00:00:00Z',
      fullName: 'Микита Литвин',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: '69081d32-c16f-411c-951d-8c9888456f6a',
      email: 'romanstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-06-07T00:00:00Z',
      fullName: 'Роман Степаненко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: 'b3134d6c-3533-4330-a226-ae03f1a4c1df',
      email: 'iuriishevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-07-17T00:00:00Z',
      fullName: 'Юрій Шевченко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: 'dabdec04-e147-4bf5-af44-722e6289d9f4',
      email: 'taraszinchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-02-18T00:00:00Z',
      fullName: 'Тарас Зінченко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: 'e60ef99e-abc8-4120-8a8b-11b8c5367e18',
      email: 'ostapstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-03-13T00:00:00Z',
      fullName: 'Остап Степаненко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: 'de06b56c-bca8-4b3c-9138-37bc6f2bcd08',
      email: 'levpetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-09-20T00:00:00Z',
      fullName: 'Лев Петренко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: '166cdd9a-5712-4d43-9a5b-ad22f61cc47b',
      email: 'bohdanonyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-12-16T00:00:00Z',
      fullName: 'Богдан Онищенко',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },
    {
      id: '38714be3-2807-4f37-9eef-741a6643faf5',
      email: 'vitaliisobol@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-09-16T00:00:00Z',
      fullName: 'Віталій Соболь',
      teams: [
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          name: 'SEO Team',
          description: 'SEO Team of Marketing Department',
        },
      ],
    },

    {
      id: '0c24af73-d8ac-4f79-8a25-8e0bdb205d6c',
      email: 'vitaliilytvyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2024-01-02T00:00:00Z',
      fullName: 'Віталій Литвин',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '078d1d65-9a6f-4c36-8173-5fbf9ba62e51',
      email: 'oleksiikovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-04-10T00:00:00Z',
      fullName: 'Олексій Коваленко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: 'cb58900d-1249-4fa4-9b26-035bb9ebd4c6',
      email: 'serhiionyshchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-02-05T00:00:00Z',
      fullName: 'Сергій Онищенко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '4f789807-011c-4983-8e2b-71404fc75ee3',
      email: 'andriirybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-01-14T00:00:00Z',
      fullName: 'Андрій Рибак',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '6a8bb364-03db-4941-9c5b-b8cf5a22a4c3',
      email: 'dmytrorybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-01-16T00:00:00Z',
      fullName: 'Дмитро Рибак',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '3d253df5-92c9-4ece-abb7-dcc0faf9927d',
      email: 'dmytrohrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-04-19T00:00:00Z',
      fullName: 'Дмитро Гриценко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '338b5e67-68a4-4a74-adc3-21072cffa87e',
      email: 'iaroslavskrypko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-09-07T00:00:00Z',
      fullName: 'Ярослав Скрипко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '55fc97d7-3592-4565-b617-03cce015e5a6',
      email: 'markokovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-11-15T00:00:00Z',
      fullName: 'Марко Коваленко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: 'b478fe17-718d-444d-af0d-e4b01e1cef0a',
      email: 'levmelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-12-14T00:00:00Z',
      fullName: 'Лев Мельник',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '6abe0ebf-b09e-435c-89d1-921010683f20',
      email: 'oleksiihrytsenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-09-12T00:00:00Z',
      fullName: 'Олексій Гриценко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: 'b1072906-a56d-42cf-8130-576f4053d064',
      email: 'tymurkovalenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-11-05T00:00:00Z',
      fullName: 'Тимур Коваленко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '281f8365-9617-4bab-aac9-5576281ad494',
      email: 'ihorstepanenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-03-30T00:00:00Z',
      fullName: 'Ігор Степаненко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '8718eba7-1bfd-49cf-9759-0d7fa075092f',
      email: 'mykytapetrenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2024-01-03T00:00:00Z',
      fullName: 'Микита Петренко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '78df92a4-c799-4be5-82bb-55434013fdb0',
      email: 'ihorkravchuk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2021-03-20T00:00:00Z',
      fullName: 'Ігор Кравчук',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: 'e407dcdc-3c15-47ad-a103-df8091f0451b',
      email: 'mykytashevchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2020-05-13T00:00:00Z',
      fullName: 'Микита Шевченко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '20efcc43-87e2-438c-855a-f96009c871db',
      email: 'markorybak@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2022-11-04T00:00:00Z',
      fullName: 'Марко Рибак',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '61bb2c62-12f6-4629-8b61-2608863f9e74',
      email: 'serhiimelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-26T00:00:00Z',
      fullName: 'Сергій Мельник',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '61bb2c62-dsff6-4629-8b61-2608863f9e74',
      email: 'mariazyn@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-26T00:00:00Z',
      fullName: 'Марія Зинченко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '61bb2c62-12f6-4629-8b61-26sd863f9e74',
      email: 'ludmilamelnyk@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-26T00:00:00Z',
      fullName: 'Люся  Мельник',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
    {
      id: '61bb2c62-12f6-4629-8b61-26088sdf9e74',
      email: 'viktorzynchenko@apple.com',
      role: 'user',
      status: 'active',
      joinedAt: '2023-12-26T00:00:00Z',
      fullName: 'Віктор Зинченко',
      teams: [
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          name: 'Growth Team',
          description: 'Growth Team of Marketing Department',
        },
      ],
    },
  ],
  meta: {
    page: 1,
    limit: 10,
    total: 179,
    totalPages: 17,
  },
};
